export default __webpack_public_path__ + "static/media/aysebasar-cv.8ff8fd99.pdf";